import React, { useContext, useState } from 'react';

import { default as BSToast } from 'react-bootstrap/Toast';
import { NCRContext } from 'views';

const Toast = ({ number, message, color }) => {

  const { state } = useContext(NCRContext);

  const [show, setShow] = useState(true);

  return (
    <>
      <BSToast
        onClose={() => setShow(false)}
        show={show}
        delay={10000}
        autohide
        style={{
          position: 'fixed',
          top: 5,
          right: 5,
          minWidth: '300px',
          zIndex: 1500,
          backgroundColor: color || 'AliceBlue'
        }}
      >
        <BSToast.Header>
          <strong className="mr-auto">
            {state.ncr.number || ''}
          </strong>
        </BSToast.Header>
        <BSToast.Body>{message}</BSToast.Body>
      </BSToast>
    </>
  )
}

export { Toast };
